import { handleApi } from "./common";

const ORDERS_AUTH_API = {
  campaignDetails: "/page/invest/auth/campaign",
  generateOtp: "/api/invest/auth/generate/otp",
  resendOtp: "/api/invest/auth/resend/otp",
  verifyOtp: "/api/invest/auth/verify/otp",
};

export const fetch_campaign_details = async (Api, urlSafeKey, token) => {
  const response = await Api.get(
    `${ORDERS_AUTH_API.campaignDetails}/${urlSafeKey}`,
    {},
    {},
    token
  );
  return handleApi(response);
}

export const generateOtp = async (Api, urlSafeKey, token) => {
  const response = await Api.get(`${ORDERS_AUTH_API.generateOtp}?urlsafe_key=${urlSafeKey}`, {}, {}, token);
  return handleApi(response)
};

export const resendOtp = async (Api, urlSafeKey, token) => {
  const response = await Api.get(`${ORDERS_AUTH_API.resendOtp}?urlsafe_key=${urlSafeKey}`, {}, {}, token);
  return handleApi(response)
};

export const verifyOtp = async (Api, payload, token) => {
  const response = await Api.post(`${ORDERS_AUTH_API.verifyOtp}`, payload, {}, token);
  return handleApi(response)
};
